import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {medify, webapi} from '../../shared/my-constants';

@Injectable()
export class InvItemService {
  invItem: any;
  private headers = new Headers({'Content-Type': 'application/json'});
    private headers1 = new Headers({
        'Content-Type': 'application/json',
        'pharmacy_Key': '3D1japAizUClyEAUZfglpBIEvasPSSdy'
    });

  private ListRecord = webapi + 'inv_item/list/?';
    private DeactiveListRecord = webapi + 'inv_item/deactiveList/?';
   // private DeactiveListRecord = webapi + 'inv_item/deactiveList/?';
  private AddRecord = webapi + 'inv_item/create';
  private EditRecord = webapi + 'inv_item/update';
  private GetRecord = webapi + 'inv_item/byid/';
  private DeleteRecord = webapi + 'inv_item/delete/';
    private ReActiveRecord = webapi + 'inv_item/reActive/';
  private ListRecordForAllergies = webapi + 'inv_item/listforAllergies/';
  private GetAllItemsByAll = webapi + 'inv_item/byall/';
  private GetdilogSearch = webapi + 'inv_item/forDilogSearch/';
  private GetdilogSearchByStoreId = webapi + 'inv_item/forDilogSearchByStoreId/';
  private GetorDilogSearchBy = webapi + 'inv_item/forDilogSearchBy/';
  private SaveComponent = webapi + 'tinv_item_component/create';
  private ListRecordByUnitId = webapi + 'inv_item/listByUnitId/?';
  private GetDropDown = webapi + 'inv_item/dropdown?';
  //  Search Tables in CPOE
  private SearchTables = webapi + 'inv_item/searchTables?';
    private SaveItemMedi=medify+ 'webservices/api/store/ ';
    private GetPharmacyStoreList = webapi + 'inv_store/getPharmacyStoreList';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
    return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordForAllergiesService(): Promise<any> {
    return this.http.get(this.ListRecordForAllergies)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.DeactiveListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getTablesinCPOE(data: any) {
    return this.http.get(this.SearchTables + 'data=' + data)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  getRecordsByAll(data: any) {
    return this.http.get(this.GetAllItemsByAll + data)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getListOfItemsDependsOnSerch(model: any) {
    return this.http.put(this.GetdilogSearch, JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
  }
  getListOfItemsDependsOnSerchByStoreId(model: any) {
    return this.http.put(this.GetdilogSearchByStoreId, JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
  }
 getListOfItemsDependsOnSerchBy(model: any) {
    return this.http.put(this.GetorDilogSearchBy , JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
  }

  onSaveComponents(model: any) {
    return this.http.post(this.SaveComponent, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getDropDown(currentPage: any, size: any, globalFilter: any): Promise<any> {
    return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    addRecordService1(user: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.SaveItemMedi, JSON.stringify(user), {headers: this.headers1})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
     


// getPharmacyStoreListMedifyHub(): Promise<any> {
//     return this.http
//         .get(this.GetPharmacyStoreList, { headers: this.headers1 })
//         .toPromise()
//         .then(res => res.json())
//         .catch(this.handleError);
// }


    getTablesinCPOEMedifyHub(data: string, storeId: number): Promise<any> {
    return this.http
        .get(this.SearchTables + 'data=' + data + '&storeId=' + storeId)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
    }

    getPharmacyStoreListMedifyHub(): Promise<any> {
      return this.http.get(
        webapi + 'inv_store/getPharmacyStoreList'
      )
      .toPromise()
      .then(res => res.json());
    }

   

}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/inv-item/inv-item.service.ts